import { EventBus } from '@confluence/generics';

import type { FlagMessages } from './types.ts';

/**
 * Flag Event Bus
 *
 * An event bus for subscribing to the notification state of the
 * application. This event bus will receive events for enabling
 * and disabling notifications during a few key user behaviors:
 *
 * 1. This event bus will receive a "disable-notifications" message
 *    when a user focuses into a comment editor.
 * 2. When the user focuses out of the editor. The bus will then
 *    receive an "enable-notifications" message
 * 3. If the current document reaches the background during a user
 *    session, the event bus will receive a "disable-notifications"
 *    message
 * 4. When the current document is moved back into the foreground
 *    the bus will then receive an an "enable-notifications" message
 *
 * When building features that consume the Flags package, you may
 * subscribe to the messages in this bus to best decide whether to
 * show or delay showing flags to your users
 *
 * To subscribe to the `FlagEventBus`, you can make a call to:
 *
 * ```
 * const ListenerID = FlagEventBus.on("enable-notifications", () => {});
 * const ListenerID FlagEventBus.on("disable-notifications", () => {});
 * ```
 * and
 * ```
 * FlagEventBus.off("enable-notifications", ListenerID);
 * FlagEventBus.off("disable-notifications", ListenerID);
 * ```
 */
export const FlagEventBus: EventBus<FlagMessages> = new EventBus<FlagMessages>();
